// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2_ZxR","vLegacy":"SelectSecondary_vLegacy__BBB-i","error":"SelectSecondary_error___Q4Kn","disabled":"SelectSecondary_disabled__1HwmP"};